/**
 * ServiceTechniqueAgentTabs.tsx — barre d'onglets pour l'AGENT.
 *
 * Depuis le fix nav mobile (juillet 2026), délègue au nav partagé
 * `ServiceTechniqueNav`, qui restreint automatiquement l'affichage pour le rôle
 * agent (menu déroulant Planning = Ma tournée + Présence, plus Fiches incident).
 * Conserve son ancienne signature pour ne pas casser MaTourneePage / PresencePage.
 */

import { ServiceTechniqueNav } from '@/components/ServiceTechniqueNav';

export type STAgentTab = 'planning' | 'presence';

export function ServiceTechniqueAgentTabs({ active }: { active: STAgentTab }) {
  return (
    <nav
      aria-label="Navigation Service technique"
      className="border-b border-border backdrop-blur-glass px-4 py-2"
      style={{ backgroundImage: 'linear-gradient(180deg, oklch(var(--c-bg-2) / 0.3), oklch(var(--c-bg) / 0.4))' }}
    >
      <div className="mx-auto max-w-[1400px]">
        <ServiceTechniqueNav active={active} />
      </div>
    </nav>
  );
}
